export * from './tag-pill-purpose';
export * from './tag-pill.component';
export * from './tag-pill.module';
